/**
 * Specifies the type of deletion to be performed.
 *
 */
export var DeletionType;
(function (DeletionType) {
    DeletionType["Partial"] = "partial";
    DeletionType["Entire"] = "entire";
})(DeletionType || (DeletionType = {}));
